let CurrencySymbol = [
  { label: '--choose--', value: ''},
  { label: 'AED - د.إ', value: 'AED' },
  { label: 'AFN - ؋', value: 'AFN' },
  { label: 'ALL - L', value: 'ALL' },
  { label: 'AMD - ֏', value: 'AMD' },
  { label: 'ANG - ƒ', value: 'ANG' },
  { label: 'AOA - Kz', value: 'AOA' },
  { label: 'ARS - $', value: 'ARS' },
  { label: 'AUD - $', value: 'AUD' },
  { label: 'AWG - ƒ', value: 'AWG' },
  { label: 'AZN - ₼', value: 'AZN' },
  { label: 'BAM - KM', value: 'BAM' },
  { label: 'BBD - $', value: 'BBD' },
  { label: 'BDT - ৳', value: 'BDT' },
  { label: 'BGN - лв', value: 'BGN' },
  { label: 'BHD - .د.ب', value: 'BHD' },
  { label: 'BIF - FBu', value: 'BIF' },
  { label: 'BMD - $', value: 'BMD' },
  { label: 'BND - $', value: 'BND' },
  { label: 'BOB - $b', value: 'BOB' },
  { label: 'BOV - BOV', value: 'BOV' },
  { label: 'BRL - R$', value: 'BRL' },
  { label: 'BSD - $', value: 'BSD' },
  { label: 'BTC - ₿', value: 'BTC' },
  { label: 'BTN - Nu.', value: 'BTN' },
  { label: 'BWP - P', value: 'BWP' },
  { label: 'BYN - Br', value: 'BYN' },
  { label: 'BYR - Br', value: 'BYR' },
  { label: 'BZD - BZ$', value: 'BZD' },
  { label: 'CAD - $', value: 'CAD' },
  { label: 'CDF - FC', value: 'CDF' },
  { label: 'CHE - CHE', value: 'CHE' },
  { label: 'CHF - CHF', value: 'CHF' },
  { label: 'CHW - CHW', value: 'CHW' },
  { label: 'CLF - CLF', value: 'CLF' },
  { label: 'CLP - $', value: 'CLP' },
  { label: 'CNH - ¥', value: 'CNH' },
  { label: 'CNY - ¥', value: 'CNY' },
  { label: 'COP - $', value: 'COP' },
  { label: 'COU - COU', value: 'COU' },
  { label: 'CRC - ₡', value: 'CRC' },
  { label: 'CUC - $', value: 'CUC' },
  { label: 'CUP - ₱', value: 'CUP' },
  { label: 'CVE - $', value: 'CVE' },
  { label: 'CZK - Kč', value: 'CZK' },
  { label: 'DJF - Fdj', value: 'DJF' },
  { label: 'DKK - kr', value: 'DKK' },
  { label: 'DOP - RD$', value: 'DOP' },
  { label: 'DZD - دج', value: 'DZD' },
  { label: 'EEK - kr', value: 'EEK' },
  { label: 'EGP - £', value: 'EGP' },
  { label: 'ERN - Nfk', value: 'ERN' },
  { label: 'ETB - Br', value: 'ETB' },
  { label: 'ETH - Ξ', value: 'ETH' },
  { label: 'EUR - €', value: 'EUR' },
  { label: 'FJD - $', value: 'FJD' },
  { label: 'FKP - £', value: 'FKP' },
  { label: 'GBP - £', value: 'GBP' },
  { label: 'GEL - ₾', value: 'GEL' },
  { label: 'GGP - £', value: 'GGP' },
  { label: 'GHC - ₵', value: 'GHC' },
  { label: 'GHS - GH₵', value: 'GHS' },
  { label: 'GIP - £', value: 'GIP' },
  { label: 'GMD - D', value: 'GMD' },
  { label: 'GNF - FG', value: 'GNF' },
  { label: 'GTQ - Q', value: 'GTQ' },
  { label: 'GYD - $', value: 'GYD' },
  { label: 'HKD - $', value: 'HKD' },
  { label: 'HNL - L', value: 'HNL' },
  { label: 'HRK - kn', value: 'HRK' },
  { label: 'HTG - G', value: 'HTG' },
  { label: 'HUF - Ft', value: 'HUF' },
  { label: 'IDR - Rp', value: 'IDR' },
  { label: 'ILS - ₪', value: 'ILS' },
  { label: 'IMP - £', value: 'IMP' },
  { label: 'INR - ₹', value: 'INR' },
  { label: 'IQD - ع.د', value: 'IQD' },
  { label: 'IRR - ﷼', value: 'IRR' },
  { label: 'ISK - kr', value: 'ISK' },
  { label: 'JEP - £', value: 'JEP' },
  { label: 'JMD - J$', value: 'JMD' },
  { label: 'JOD - JD', value: 'JOD' },
  { label: 'JPY - ¥', value: 'JPY' },
  { label: 'KES - KSh', value: 'KES' },
  { label: 'KGS - лв', value: 'KGS' },
  { label: 'KHR - ៛', value: 'KHR' },
  { label: 'KMF - CF', value: 'KMF' },
  { label: 'KPW - ₩', value: 'KPW' },
  { label: 'KRW - ₩', value: 'KRW' },
  { label: 'KWD - KD', value: 'KWD' },
  { label: 'KYD - $', value: 'KYD' },
  { label: 'KZT - ₸', value: 'KZT' },
  { label: 'LAK - ₭', value: 'LAK' },
  { label: 'LBP - £', value: 'LBP' },
  { label: 'LKR - ₨', value: 'LKR' },
  { label: 'LRD - $', value: 'LRD' },
  { label: 'LSL - M', value: 'LSL' },
  { label: 'LTC - Ł', value: 'LTC' },
  { label: 'LTL - Lt', value: 'LTL' },
  { label: 'LVL - Ls', value: 'LVL' },
  { label: 'LYD - LD', value: 'LYD' },
  { label: 'MAD - MAD', value: 'MAD' },
  { label: 'MDL - lei', value: 'MDL' },
  { label: 'MGA - Ar', value: 'MGA' },
  { label: 'MKD - ден', value: 'MKD' },
  { label: 'MMK - K', value: 'MMK' },
  { label: 'MNT - ₮', value: 'MNT' },
  { label: 'MOP - MOP$', value: 'MOP' },
  { label: 'MRO - UM', value: 'MRO' },
  { label: 'MRU - UM', value: 'MRU' },
  { label: 'MUR - ₨', value: 'MUR' },
  { label: 'MVR - Rf', value: 'MVR' },
  { label: 'MWK - MK', value: 'MWK' },
  { label: 'MXN - $', value: 'MXN' },
  { label: 'MXV - MXV', value: 'MXV' },
  { label: 'MYR - RM', value: 'MYR' },
  { label: 'MZN - MT', value: 'MZN' },
  { label: 'NAD - $', value: 'NAD' },
  { label: 'NGN - ₦', value: 'NGN' },
  { label: 'NIO - C$', value: 'NIO' },
  { label: 'NOK - kr', value: 'NOK' },
  { label: 'NPR - ₨', value: 'NPR' },
  { label: 'NZD - $', value: 'NZD' },
  { label: 'OMR - ﷼', value: 'OMR' },
  { label: 'PAB - B/.', value: 'PAB' },
  { label: 'PEN - S/.', value: 'PEN' },
  { label: 'PGK - K', value: 'PGK' },
  { label: 'PHP - ₱', value: 'PHP' },
  { label: 'PKR - ₨', value: 'PKR' },
  { label: 'PLN - zł', value: 'PLN' },
  { label: 'PYG - Gs', value: 'PYG' },
  { label: 'QAR - ﷼', value: 'QAR' },
  { label: 'RMB - ￥', value: 'RMB' },
  { label: 'RON - lei', value: 'RON' },
  { label: 'RSD - Дин.', value: 'RSD' },
  { label: 'RUB - ₽', value: 'RUB' },
  { label: 'RWF - R₣', value: 'RWF' },
  { label: 'SAR - ﷼', value: 'SAR' },
  { label: 'SBD - $', value: 'SBD' },
  { label: 'SCR - ₨', value: 'SCR' },
  { label: 'SDG - ج.س.', value: 'SDG' },
  { label: 'SEK - kr', value: 'SEK' },
  { label: 'SGD - S$', value: 'SGD' },
  { label: 'SHP - £', value: 'SHP' },
  { label: 'SLL - Le', value: 'SLL' },
  { label: 'SOS - S', value: 'SOS' },
  { label: 'SRD - $', value: 'SRD' },
  { label: 'SSP - £', value: 'SSP' },
  { label: 'STD - Db', value: 'STD' },
  { label: 'STN - Db', value: 'STN' },
  { label: 'SVC - $', value: 'SVC' },
  { label: 'SYP - £', value: 'SYP' },
  { label: 'SZL - E', value: 'SZL' },
  { label: 'THB - ฿', value: 'THB' },
  { label: 'TJS - SM', value: 'TJS' },
  { label: 'TMT - T', value: 'TMT' },
  { label: 'TND - د.ت', value: 'TND' },
  { label: 'TOP - T$', value: 'TOP' },
  { label: 'TRL - ₤', value: 'TRL' },
  { label: 'TRY - ₺', value: 'TRY' },
  { label: 'TTD - TT$', value: 'TTD' },
  { label: 'TVD - $', value: 'TVD' },
  { label: 'TWD - NT$', value: 'TWD' },
  { label: 'TZS - TSh', value: 'TZS' },
  { label: 'UAH - ₴', value: 'UAH' },
  { label: 'UGX - USh', value: 'UGX' },
  { label: 'USD - $', value: 'USD' },
  { label: 'UYI - UYI', value: 'UYI' },
  { label: 'UYU - $U', value: 'UYU' },
  { label: 'UYW - UYW', value: 'UYW' },
  { label: 'UZS - лв', value: 'UZS' },
  { label: 'VEF - Bs', value: 'VEF' },
  { label: 'VES - Bs.S', value: 'VES' },
  { label: 'VND - ₫', value: 'VND' },
  { label: 'VUV - VT', value: 'VUV' },
  { label: 'WST - WS$', value: 'WST' },
  { label: 'XAF - FCFA', value: 'XAF' },
  { label: 'XBT - Ƀ', value: 'XBT' },
  { label: 'XCD - $', value: 'XCD' },
  { label: 'XOF - CFA', value: 'XOF' },
  { label: 'XPF - ₣', value: 'XPF' },
  { label: 'XSU - Sucre', value: 'XSU' },
  { label: 'XUA - XUA', value: 'XUA' },
  { label: 'YER - ﷼', value: 'YER' },
  { label: 'ZAR - R', value: 'ZAR' },
  { label: 'ZMW - ZK', value: 'ZMW' },
  { label: 'ZWD - Z$', value: 'ZWD' },
  { label: 'ZWL - $', value: 'ZWL' }
];

export {CurrencySymbol}